import { DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { makeStyles } from 'tss-react/mui';
import { CreateContactForm } from '../../../../sic-lib/types/Contact';
import { FormFieldCreateContact } from '../../../../sic-lib/types/ContactField';

const useStyles = makeStyles()({
    root: {
        '& input': {
            /* matching padding toTextField size attribute 'small' */
            paddingTop: '10.5px',
            paddingBottom: '10.5px',
        },
    },
});

type Props = {
    field: FormFieldCreateContact;
    onChangeHandler: (key: keyof CreateContactForm, field: FormFieldCreateContact) => void;
    error: boolean;
    helperText: string;
};

export default function ContactFormFieldDate({ field, onChangeHandler, error, helperText }: Props) {
    const { classes } = useStyles();

    const handleChange = (date: DateTime | null) => {
        onChangeHandler('date', {
            ...field,
            ...{
                value: date ? date.toString() : '',
            },
        });
    };

    return (
        <DatePicker
            slotProps={{
                textField: {
                    name: 'dtpStartDate',
                    error: error,
                    helperText: helperText,
                    fullWidth: true,
                },
            }}
            label={field.label}
            format="yyyy/MM/dd"
            onChange={handleChange}
            className={classes.root}
        />
    );
    return null;
}
